<div class="pdf-page app-aul-013-24" id="westvirginia1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>WEST VIRGINIA CHANGES</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b>
      This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <div>
    <ol type="1" start="1" class="font-medium" style="font-weight: bold;">
      <li>
        <p>
          An insurer that is not licensed in this state is issuing the insurance
          policy that you have applied to purchase. These companies are called
          "nonadmitted" or "surplus lines" insurers.
        </p>
      </li>
      <li>
        <p>
          The insurer is not subject to the financial solvency regulation and
          enforcement that applies to licensed insurers in this state.
        </p>
      </li>
      <li>
        <p>
          These insurers generally do not participate in insurance guaranty
          funds created by state law. These guaranty funds will not pay your
          claims or protect your assets if the insurer becomes insolvent and is
          unable to make payments as promised.
        </p>
      </li>
      <li>
        <p>
          Some states maintain lists of approved or eligible surplus lines
          insurers and surplus lines brokers may use only insurers on the lists.
          Some states issue orders that particular surplus lines insurers cannot
          be used.
        </p>
      </li>
      <li>
        <p>
          For additional information about the above matters and about the
          insurer, you should ask questions of your insurance agent or surplus
          lines licensee. You may also contact your Insurance Commission
          consumer help line.
        </p>
      </li>
    </ol>
  </div>
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <ol style="padding-left: 12px" type="I" start="1">
      <li>
        In any cause of action arising under this policy, or certificate, cover
        note, or other confirmation of this insurance issued by your surplus
        lines agent, we will, at your request, submit to the jurisdiction of a
        court of competent jurisdiction within the United States. Nothing herein
        constitutes or should be understood to constitute a waiver of our rights
        to commence an action in any court of competent jurisdiction in the
        United States to remove an action to a United States District Court or
        to seek a transfer of a case to another court as permitted by the laws
        of the United States or of any state in the United States. In any suit
        instituted against us upon this policy, we will abide by the final
        decision of such court or of any appellate court in the event of appeal.
      </li>
      </ol>
    </div>
</div>
<div class="pdf-page app-aul-013-24">
  <div>
    <ol style="padding-left: 12px" type="I" start="2">
      <li>
        All lawful process may be served in any action, suit or proceeding
        instituted by, or on behalf of, you or any beneficiary under this
        policy, against us arising out of this policy, upon:
        <br />
        <b>Corporate Creations Network Inc.</b><br />
        <b>126 East Burke Street</b><br />
        <b>Martinsburg, WV 25401</b><br />
        <b>Berkeley County</b><br />
        <b>Phone: (561) 694-8107</b>
      </li>
    </ol>
    <ol style="padding-left: 12px" type="I" start="3">
      <li>
        Pursuant to any law of any state, the District of Columbia or territory
        of the United States which makes provision therefore, we hereby
        designate the Superintendent, Commissioner or Director of Insurance or
        other applicable individual specified for that purpose in the applicable
        statute or regulation...
      </li>
    </ol>
    
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
  </div>
</div>
